import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { SearchComponentDef } from '@df/search/search.component.def';
@Component({
    selector: 'off-canvas-search',
    templateUrl: './off-canvas-search.html',
    standalone: true,
    imports: [FormsModule, OffClickModule]
})
export class OffCanvasSearchComponent extends SearchComponentDef {
    keyup(event: KeyboardEvent): void {
        if (event.key === 'Enter' || event.code === 'Enter') {
            this.input?.nativeElement.blur();
            this.goToSearch();
        }
    }
}
